import React, {Fragment} from 'react';
import {Nav, Navbar, Container, NavDropdown} from "react-bootstrap";

const HeaderNavbar = ( {menuDescriptor}) =>
{
    const renderDropdown = ( dropdown, index ) =>
    {
        const elements = dropdown.items ;

        return (
            <NavDropdown title={dropdown.title} id={dropdown.id} key={index}>
                {
                    elements.map(( element, index) =>
                    {
                        if ( element.type === "item" )
                        {
                            return <NavDropdown.Item href={element.href} target={element.target} key={'inner' + index }>{element.text}</NavDropdown.Item>
                        }
                        else  if ( element.type === "divider" )
                        {
                            return <NavDropdown.Divider key={'inner' + index }/>
                        }
                    })
                }
            </NavDropdown>
        )
    }
    const renderMenu = ( elements ) =>
    {
        return ( elements.map(( element, index) =>
        {
            if ( element.type === "link" )
            {
                return <Nav.Link href={element.href} target={element.target} key={index}>{element.text}</Nav.Link>
            }
            else if ( element.type === "dropdown" )
            {
                return renderDropdown( element, index );
            }
        }))
    }

    return (
        <Navbar expand="lg">
            <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
                    <Nav style={{}}>
                        { renderMenu ( menuDescriptor )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default HeaderNavbar;
